import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7 3h2v4h4v2H9v4H7V9H3V7h4V3z" }));
export default SvgAdd;
